import { Status } from 'app/shared/model/enumerations/status.model';

export interface IConsEducationDocumentType {
  id?: number;
  code?: string;
  name?: string;
  nameAr?: string;
  nameEn?: string;
  folderName?: string;
  status?: Status;
}

export const defaultValue: Readonly<IConsEducationDocumentType> = {};
